import { Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { DateTime } from 'luxon'

import { Input } from '@presentation/components/molecules'
import { DateTimeInputProps } from '@presentation/types/components/molecules'

const CustomInput: React.FC<Object> = props => {
  return <Input {...props} />
}

const DISPLAY_FORMAT = 'dd/MM/yyyy HH:mm'
const EMPTY_MASK = ['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a', '-', '-', ':', '-']

const toDisplayValue = (value?: string) => {
  if (!value) return ''

  const parsedValue = DateTime.fromISO(value)

  if (parsedValue.isValid) {
    return parsedValue.toFormat(DISPLAY_FORMAT)
  }

  return value
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({
  control,
  name = '',
  ...rest
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref, name: fieldName }
      }) => (
        <NumberFormat
          customInput={CustomInput}
          format="##/##/#### ##:##"
          mask={EMPTY_MASK}
          value={toDisplayValue(value)}
          onValueChange={({ formattedValue }) => {
            onChange(formattedValue)
            onBlur()
          }}
          getInputRef={ref}
          name={fieldName}
          allowEmptyFormatting
          inputMode="numeric"
          placeholder="dd/mm/aaaa --:--"
          {...rest}
        />
      )}
    />
  )
}

export default DateTimeInput
